import type {
  QueryParams,
  QueryParam,
} from '@/modules/common/context/QueryParams/models';
import type {QueryParamsSchema} from '@/modules/common/context/QueryParams/schema';

export const stringifyWithSchema = ({
  queryParams,
  schema,
}: {
  queryParams: Partial<QueryParams>;
  schema: QueryParamsSchema;
}): Partial<Record<keyof QueryParams, string>> => {
  return Object.fromEntries(
    Object.entries(queryParams).map(([key, value]) => {
      if (value === null || value === undefined) {
        return [key, ''];
      }
      if (key in schema) {
        const {stringify} = schema[key as QueryParam];
        // @ts-expect-error ...
        return [key, stringify(value)];
      }
      return [key, value];
    })
  );
};
